export function priceFormat(price?: string|number|null) {
  return parseFloat(price?.toString() || '0')
      .toLocaleString('ru-RU', { minimumFractionDigits: 2 }).replace(',00', '')
}